module.exports = __webpack_public_path__ + "img/gb13871-92-6x22x7.prt.a4a30b0d.jpg";